<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xTCjzv/tc-custom/9781685507091.jpg?1723407039816" alt="This image is the cover for the book Smoking Mirror"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smoking Mirror
      </h1>
      <p class="bookDescription body article font2">
        <p>When Draco attends a ball held by the Aztec emperor to celebrate his victory over sky pirates, Draco meets the attractive and enigmatic Yolotli. However, a vindictive act sees Draco forced to captain a unique ship, the <i>Nephele</i>. The first ship designed to sail the oceans of space, and built by the combined forces of the British and Aztec Empires.<br/><br/>Draco is obligated to take Yolotli with him, bound under an oath by the emperor. Their lives, as well as their burgeoning love, are beset with dangers neither man could imagine.<br/><br/>Even if they survive the mission, their love may not endure when the truth is revealed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pelaam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b71eb016